export const findSelectedYarnGroup = (dataset, colourIdFromUrl) => {
    const targetId = parseInt(colourIdFromUrl, 10);
    for (const yarnGroup of dataset.yarn_groups) {
        for (const colourOption of yarnGroup.yarn_colours) {
            for (const swatch of colourOption.swatches) {
                if (swatch.id === targetId) {
                    return yarnGroup;
                }
            }
        }
    }
    return null; // No matching yarn group found
};
export const calculateBundlePrice = (currentBundle, includeAddOns, included_tools) => {
    let bundleTotalPrice, bundleTotalComparePrice;
    bundleTotalPrice = currentBundle.variant.price;
    bundleTotalComparePrice = currentBundle.variant.compare_at_price ? currentBundle.variant.compare_at_price : currentBundle.variant.price;
    // Add the price of the colours/yarns
    currentBundle.colours.forEach((colour, index) => {
        const quantity = currentBundle.variant.yarn_group.yarn_colours[index].quantity;
        bundleTotalPrice += (colour === null || colour === void 0 ? void 0 : colour.price) * quantity;
        bundleTotalComparePrice += (colour === null || colour === void 0 ? void 0 : colour.compare_at_price) ? (colour === null || colour === void 0 ? void 0 : colour.compare_at_price) * quantity : (colour === null || colour === void 0 ? void 0 : colour.price) * quantity;
    });
    // Add the price of the addons
    if (includeAddOns) {
        currentBundle.addOns.forEach((addOn) => {
            bundleTotalPrice += addOn.price;
            bundleTotalComparePrice += addOn.compare_at_price ? addOn.compare_at_price : addOn.price;
        });
    }
    // Add the price of the included tools
    if (included_tools && included_tools.length > 0) {
        included_tools.forEach((tool) => {
            bundleTotalPrice += tool.price;
            bundleTotalComparePrice += tool.compare_at_price ? tool.compare_at_price : tool.price;
        });
    }
    const prices = {
        totalBase: bundleTotalPrice,
        totalCompare: bundleTotalComparePrice,
        colours: currentBundle.colours.map((colour) => colour === null || colour === void 0 ? void 0 : colour.price),
        addons: currentBundle.addOns.map((addon) => addon.price),
    };
    return prices;
};
